import React from 'react';
import { fetchLoanReminders } from 'actions/loans';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { date } from 'utils/date';
import { dollars } from 'utils/money';
import LoanDialog from 'components/Loans/LoanDialog';
import AlertDialog from 'components/AlertDialog';
import LoanScheduleNoteDialog from 'components/Loans/LoanScheduleNoteDialog';
import { confirmRepayment, noteLoanSchedule, notifyCustomer } from 'actions/loans';
import { Link } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Notifications from '@material-ui/icons/Notifications';

const styles = theme => ({
  responsiveTable: {
    overflowX: 'scroll'
  },
  overDue: {
    backgroundColor: '#EF9A9A',
  },
  dueToday: {
    backgroundColor: '#FFE082',
  },
  note: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  notiIcon: { fontSize: 20 }
});

export class LoanScheduleReminder extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchLoanReminders());
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} style={{position: 'absolute', zIndex: '1', top: '50%', left: '50%'}}/>
      );
    }
  }

  classSelector = (repaymentDatetime) => {
    const timeDiff = moment().diff(moment(repaymentDatetime));
    if ( timeDiff >= 0) {
      return this.props.classes.overDue;
    } else if (moment(repaymentDatetime).isSame(moment(), 'day')) {
      return this.props.classes.dueToday;
    }
  }

  renderRepaymentInitialConfirmation(schedule) {
    const initialRepaymentEvent = schedule.repaymentEvents[0];
    if (initialRepaymentEvent) {
      return date(initialRepaymentEvent.paidAt);
    } else {
      return (
        <AlertDialog
          buttonLabel='Confirm'
          variant='raised'
          color='primary'
          confirmAction={()=>{this.props.dispatch(confirmRepayment(schedule.id, 'paid'))}}
          title='You are about to confirm the repayment has been received.'
          desc='This is the first confirmation for receiving the repayment. After the completion of the first confirmation, you will need another confirmation to finalize repayment receiption for this loan schedule.'
        />
      );
    }
  }

  renderRepaymentFinalConfirmation(schedule) {
    const finalRepaymentEvent = schedule.repaymentEvents[1];
    if (finalRepaymentEvent) {
      return date(finalRepaymentEvent.paidAt);
    } else if (schedule.repaymentEvents[0]) {
      return (
        <AlertDialog
          buttonLabel='Confirm'
          variant='raised'
          color='secondary'
          confirmAction={()=>{this.props.dispatch(confirmRepayment(schedule.id, 'cleared'))}}
          title='You are about to confirm the repayment has been received.'
          desc='This is the first confirmation for receiving the repayment. After the completion of the first confirmation, you will need another confirmation to finalize repayment receiption for this loan schedule.'
        />
      );
    }
  }

  renderEditNote = (schedule) => {
    return (
      <LoanScheduleNoteDialog
        color='primary'
        buttonLabel={null}
        save={(note)=>{this.props.dispatch(noteLoanSchedule(schedule.id, note))}}
        title='Loan Schedule Note'
        note={schedule.note}
      />
    )
  }

  renderNotifyCustomer = (schedule) => {
    return (
      <AlertDialog
        icon={(<Notifications color='secondary' className={this.props.classes.notiIcon}/>)}
        buttonLabel={`(${schedule.notifications.length})`}
        title=''
        confirmAction={()=>{this.props.dispatch(notifyCustomer(schedule.id))}}
        desc='You are about to send customer a reminder email about this loan schedule. Click Yes to confirm.'
      />
    );
  }

  renderLoans = () => {
    return (
      <div>
        { this.renderSpinner() }
        <Table className={this.props.classes.responsiveTable}>
          <TableHead>
            <TableRow>
              <TableCell>Org</TableCell>
              <TableCell>Loan Number</TableCell>
              <TableCell>Application Number</TableCell>
              <TableCell>Repayment Date</TableCell>
              <TableCell>Total payable</TableCell>
              <TableCell>Repayment Initial Confirmation Date</TableCell>
              <TableCell>Repayment Final Confirmation Date</TableCell>
              <TableCell>Note</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              Object.values(this.props.loans).map(loan => {
                return loan.loanSchedules.map(schedule => {
                  return (
                    <TableRow key={`loanSchedule${schedule.id}`} className={this.classSelector(schedule.repaymentDatetime)} >
                      <TableCell>
                        <Link to={`/organisations/${loan.organisation.id}`}>
                          { loan.organisation.name }
                        </Link>
                      </TableCell>
                      <TableCell>
                        {
                          <LoanDialog
                            loan={loan}
                            buttonLabel={loan.loanNumber}
                          />
                        }
                      </TableCell>
                      <TableCell>
                        <Link to={`/applications/${loan.applicationNumber}`}>
                          { loan.applicationNumber }
                        </Link>
                      </TableCell>
                      <TableCell>
                        { date(schedule.repaymentDatetime) }
                      </TableCell>
                      <TableCell>
                        { dollars(schedule.totalPayable) }
                      </TableCell>
                      <TableCell>
                        { this.renderRepaymentInitialConfirmation(schedule) }
                      </TableCell>
                      <TableCell>
                        { this.renderRepaymentFinalConfirmation(schedule) }
                      </TableCell>
                      <TableCell>
                        { schedule.note }
                      </TableCell>
                      <TableCell>
                        <div className={this.props.classes.note} >
                          { this.renderEditNote(schedule) }
                          { this.renderNotifyCustomer(schedule) }
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                })
              })
            }
          </TableBody>
        </Table>
      </div>
    );
  }

  render = () => {
    if (!this.props.loans) {
      return null;
    }
    return (
      <div>
        <Typography variant='headline'>
          Repayments
        </Typography>
        { this.renderLoans() }
      </div>
    );
  };
}


const mapStateToProps = (state, ownProps) => {
  return {
    loans: state.loans.loans,
    showSpinner: state.app.showSpinner
  }
};

const styled = withStyles(styles)(LoanScheduleReminder)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Loans/LoanScheduleReminder.js